import { useContext, useEffect } from 'react';
import { Container, Divider, Space, Switch } from '@mantine/core';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DndProvider } from 'react-dnd-latest';
import { HTML5Backend } from 'react-dnd-html5-backend-latest';
import DocumentHeadData from '../../Molecules/DocumentHeadData';
import DocumentHeadTemplate from '../DocumentHeadTemplate';
import { DocumentContext } from '../../Service/Context/DocumentContextV2';
import DocumentSkeleton from '../../Organismns/Document/DocumentSkeletonV2';
import { DocumentS } from '../Documents/DocumentS';
import { isDefined } from '../../Service/ValidationS';
import { useXRechnungValidator } from '../../Service/hooks/useXRechnungValidator';
import { WindowContext } from '../../Service/Context/WindowContext';
import { useEventCustomer } from '../../Service/Context/EventParticipationContextV2';

const DocumentEditor = () => {
  const navigate = useNavigate();
  const { sm } = useContext(WindowContext);
  const { bookitupDocument, handleChange, savePatch, loading, operationPending } = useContext(DocumentContext);
  const { id: documentId, draft, customerId, documentType, positions, eventId, language } = bookitupDocument ?? {};
  const [searchParams] = useSearchParams();
  const { customer, patchCustomer } = useEventCustomer(customerId);
  const { valid } = useXRechnungValidator(bookitupDocument, customer);
  const emptyPositions = positions !== undefined && positions.length === 0;

  const documentURL = eventId
    ? `/events/${eventId}/documents/${documentId}/preview`
    : `/documents/${documentId}/preview`;
  const title = bookitupDocument ? DocumentS.resolveLabel(bookitupDocument) : 'Dokument';

  useEffect(() => {
    if (bookitupDocument && !draft && !searchParams.get('unlock')) {
      // Redirect to document preview if no draft
      navigate('preview');
    }
  }, [bookitupDocument, draft, navigate, searchParams]);

  return (
    <Container p={0}>
      <DocumentHeadTemplate
        entityId={documentId ? documentId.toString() : ''}
        entityType="documents"
        title={loading ? 'Laden ...' : title}
        previewUrl={documentURL}
        disablePreview={emptyPositions || !valid}
        operationPending={operationPending}
        language={language}
        onLanguageChange={bookitupDocument ? (newLanguage) => savePatch({ language: newLanguage }) : undefined}
        eInvoiceSwitch={
          documentType &&
          DocumentS.isInvoice(documentType) &&
          customer && (
            <Switch
              label="E-Rechnung"
              checked={isDefined(customer.buyerReference)}
              disabled={customer.contactType === 'PRIVATE'}
              onChange={(e) => {
                patchCustomer({ buyerReference: e.target.checked ? '0' : null });
                handleChange({ xrechnungRequired: e.target.checked });
              }}
            />
          )
        }
      />
      <DocumentHeadData customer={customer} />
      <Divider my="xl" />
      <DndProvider backend={HTML5Backend}>
        <DocumentSkeleton />
      </DndProvider>
      {sm && <Space h={75} />}
    </Container>
  );
};

export default DocumentEditor;
